var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBags(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.291 17.5V18.3333C12.291 18.6783 12.571 18.9583 12.916 18.9583C13.261 18.9583 13.541 18.6783 13.541 18.3333V17.5C13.541 17.155 13.261 16.875 12.916 16.875C12.571 16.875 12.291 17.155 12.291 17.5Z",
    fill: "url(#paint0_linear_383_9718)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.125 5.83073V2.4974C8.125 2.4424 8.14667 2.38906 8.18583 2.3499C8.225 2.31073 8.27833 2.28906 8.33333 2.28906H11.6667C11.7217 2.28906 11.775 2.31073 11.8142 2.3499C11.8533 2.38906 11.875 2.4424 11.875 2.4974V5.83073C11.875 6.17573 12.155 6.45573 12.5 6.45573C12.845 6.45573 13.125 6.17573 13.125 5.83073C13.125 5.83073 13.125 3.71323 13.125 2.4974C13.125 2.11073 12.9717 1.7399 12.6975 1.46656C12.4242 1.1924 12.0533 1.03906 11.6667 1.03906C10.7417 1.03906 9.25833 1.03906 8.33333 1.03906C7.94667 1.03906 7.57583 1.1924 7.3025 1.46656C7.02833 1.7399 6.875 2.11073 6.875 2.4974V5.83073C6.875 6.17573 7.155 6.45573 7.5 6.45573C7.845 6.45573 8.125 6.17573 8.125 5.83073Z",
    fill: "url(#paint1_linear_383_9718)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45703 17.5V18.3333C6.45703 18.6783 6.73703 18.9583 7.08203 18.9583C7.42703 18.9583 7.70703 18.6783 7.70703 18.3333V17.5C7.70703 17.155 7.42703 16.875 7.08203 16.875C6.73703 16.875 6.45703 17.155 6.45703 17.5Z",
    fill: "url(#paint2_linear_383_9718)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2077 7.49479C15.2077 6.88729 14.966 6.30396 14.5368 5.87396C14.1068 5.44479 13.5235 5.20312 12.916 5.20312C11.261 5.20312 8.73768 5.20312 7.08268 5.20312C6.47518 5.20312 5.89185 5.44479 5.46185 5.87396C5.03268 6.30396 4.79102 6.88729 4.79102 7.49479V15.8281C4.79102 16.4356 5.03268 17.019 5.46185 17.449C5.89185 17.8781 6.47518 18.1198 7.08268 18.1198H12.916C13.5235 18.1198 14.1068 17.8781 14.5368 17.449C14.966 17.019 15.2077 16.4356 15.2077 15.8281V7.49479ZM11.041 8.32812V14.9948C11.041 15.3398 11.321 15.6198 11.666 15.6198C12.011 15.6198 12.291 15.3398 12.291 14.9948V8.32812C12.291 7.98312 12.011 7.70312 11.666 7.70312C11.321 7.70312 11.041 7.98312 11.041 8.32812ZM7.70768 8.32812V14.9948C7.70768 15.3398 7.98768 15.6198 8.33268 15.6198C8.67768 15.6198 8.95768 15.3398 8.95768 14.9948V8.32812C8.95768 7.98312 8.67768 7.70312 8.33268 7.70312C7.98768 7.70312 7.70768 7.98312 7.70768 8.32812Z",
    fill: "url(#paint3_linear_383_9718)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_9718",
    x1: 12.291,
    y1: 17.9167,
    x2: 13.541,
    y2: 17.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_383_9718",
    x1: 6.875,
    y1: 3.7474,
    x2: 13.125,
    y2: 3.7474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_383_9718",
    x1: 6.45703,
    y1: 17.9167,
    x2: 7.70703,
    y2: 17.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_383_9718",
    x1: 4.79102,
    y1: 11.6615,
    x2: 15.2077,
    y2: 11.6615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBags);
export default __webpack_public_path__ + "static/media/bags.28bf924c07e5b37ecf7171847bf4b10e.svg";
export { ForwardRef as ReactComponent };